import { PRODUCT_SHOWCASES } from "@/src/constants/product-showcase";
import { ShowcasePanelFull } from "./ShowcasePanelFull";
import { ShowcasePanelSplit } from "./ShowcasePanelSplit";

export function ProductShowcase({ productId }: { productId: string }) {
    const panels = PRODUCT_SHOWCASES[productId];
    if (!panels?.length) return null;

    const [first, ...rest] = panels;

    return (
        <div>
            <ShowcasePanelFull panel={first} />
            {rest.map((panel, i) => (
                <ShowcasePanelSplit key={panel.catchphrase} panel={panel} reverse={i % 2 !== 0} />
            ))}
        </div>
    );
}
